const getGraphDetails = (data,seriesMap) =>{
    if(Array.isArray(data)){
        if(typeof data[0] === "int"){
            seriesMap = { key:"x",value:"y"}
            data = data.map((val)=>{
                return {x:'x',y:val}
            })
        }
    }
    const labels = Object.keys(data[0])
    return [labels[0],labels.splice(1,),data]
}

export  {getGraphDetails}